























































import { Component, Prop, Vue } from 'vue-property-decorator';
import ToggleableText from '@/components/form/ToggleableText.vue';
import { Sheet } from '@/model/Sheet';
import { newnewPdf } from '@/lib/pdf-util';

@Component({
    components: {
        ToggleableText,
    },
    methods: {
        newnewPdf,
    },
})
export default class SheetHeader extends Vue {
    @Prop() readonly sheet?: Sheet | null;
}
